import { ModalTitle } from 'root/src/client/v2/common/components/modal/ModalTitle';
import { SignInWithProviderButton } from 'root/src/client/v2/auth/components/SignInWithProviderButton';
import { getReadablePlatform } from 'root/src/shared/platforms/helpers/getReadablePlatform';
import { platformToProvider } from 'root/src/shared/util/platformHelpers';
import { useCallback, useEffect, useState } from 'react';
import { useLocalStorage } from 'root/src/client/web/hooks/useLocalStorage';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { useModalQueryContext } from 'root/src/client/v2/common/components/modal/MountQueryModalLauncher';
export const SwitchToCreatorPlatformLauncher = () => {
    const [showModal, setShowModal] = useLocalStorage('show_switch_to_creator_platform_modal', true);
    const [dontShowAgain, setDontShowAgain] = useState(false);
    const modal = useModal();
    const { modalProps, clearSearchParams } = useModalQueryContext();
    const onClose = useCallback(() => {
        clearSearchParams();
        if (dontShowAgain) {
            setShowModal(false);
        }
    }, [dontShowAgain]);
    useEffect(() => {
        if (!showModal || !modalProps.platform || !modalProps.displayName) {
            clearSearchParams();
            return;
        }
        modal.show(<SwitchToCreatorPlatformModal platform={modalProps.platform} displayName={modalProps.displayName} setDontShowAgain={setDontShowAgain}/>, { onClose });
    }, [showModal, onClose]);
    return null;
};
export const SwitchToCreatorPlatformModal = ({ platform, displayName, setDontShowAgain }) => {
    const readablePlatform = getReadablePlatform(platform);
    return (<ModalLayout className="flex flex-col text-center">
			<ModalTitle>Do you want to re-connect {readablePlatform} channel?</ModalTitle>
			<p>Your {readablePlatform} channel <b>{displayName}</b> is linked to this account, but DareDrop doesn't have access to it right now.</p>
			<p>Sign in again to re-connect your channel and unlock your creator tools.</p>
			<SignInWithProviderButton provider={platformToProvider(platform)}/>
			<FormControlLabel control={(<Checkbox defaultChecked={false} onChange={(_, checked) => {
                setDontShowAgain(checked);
            }}/>)} label={<span className="ml-2 select-none">Don't show this message again</span>}/>
		</ModalLayout>);
};
